import { Box } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import TableComponent from 'UiKit/table-component';

import { getTableList } from 'View/report-attendance-operator/section/table/const';
import { TableSkeleton } from 'View/report-attendance-operator/component/skeleton';
import { useReportAttendanceOperatorState } from 'View/report-attendance-operator/state';

import styles from './styles.module.css';

const Table = ({ data, isFetching }) => {
  const { filterState, updateFilterState } = useReportAttendanceOperatorState();

  const onChangePagination = (page) => updateFilterState({ page });

  return (
    <Box className={styles['table__container']}>
      <Condition statement={!isFetching} fallback={<TableSkeleton />}>
        <Box className={styles['table__wrapper']}>
          <TableComponent
            columns={getTableList}
            dataSource={data?.attendanceReports}
            isDataExist={data?.isDataExist}
            isScrollable={true}
            tableName="table__report-attendance-operator"
            maxTableHeight="calc(100vh - 314px)"
            maxTableBodyHeight="calc(100vh - 378px)"
            tableComponentHeight="calc(100vh - 263px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: data?.totalData,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Box>
      </Condition>
    </Box>
  );
};

export default Table;
